import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Clipboard from 'react-clipboard.js';
import Loader from 'react-loader';
import './SocialPage.css';
import instagramProfilePic from '../../images/socialIcons/Instagram.png'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import $ from 'jquery';
import { faTimes } from '@fortawesome/fontawesome-free-solid';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { GoogleLogin } from 'react-google-login';

import {
  Row, Col, Media,
  FormGroup,
  Label,
  Input, InputGroup, InputGroupAddon,
  Modal, ModalHeader, ModalBody
} from 'reactstrap';
import Form from 'react-validation/build/form';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import _ from 'lodash';
class SocialPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fbEmail: '',
      fbClientId: "231425867421205",
      instagramClientId: '2635437976739550',
      instagramRedirectUrl: window.location.protocol + '//' + window.location.hostname + '/' + 'instagram/login',
      instagramScope: 'user_profile,user_media',
      fbName: '',
      facebookAccount: [],
      customMediaDetail: [],
      youtubeMediaDetail: [],
      periscope: [],
      invitationEmail: '',
      customSocialMedia: false,
      customRTMPSites: ['Youtube', 'Facebook', 'Instagram', 'Others'],
      broadcastType: "normal",
      customRtmpUrl: '',
      customStreamKey: '',
      customName: '',
      customSite: 'Youtube',
      youtubeLoginPopup: false,
      facebookChannelLimitExceed: false,
      youtubeChannelLimitExceed: false,
      twitterChannelLimitExceed: false,
      instagramChannelLimitExceed: false,
      startLoader: true,
      instagramMediaDetail: [],
      selectCheckBoxLimit: 5,
      username: "",
      password: ""
    }
  }

  componentDidMount = () => {
    this.getAllSocialMedia();
    this.socialMediaChannelLimit();
    this.checkPeriscopeCallbackUrl();
  }


  instagramLoginWindow = () => {
    let w = 700, h = 500;
    let self = this;
    let top = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    let left = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
    let url = "/instagram/login";
    let title = "Instagram Login";
    let win = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    win.onunload = function () { self.getAllSocialMedia(); self.socialMediaChannelLimit(); };
  }

  socialMediaChannelLimit = () => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/channel/limit',
      success: (success) => {
        this.setState({
          facebookChannelLimitExceed: success.response.facebookChannelLimitExceed,
          youtubeChannelLimitExceed: success.response.youtubeChannelLimitExceed,
          twitterChannelLimitExceed: success.response.twitterChannelLimitExceed,
          instagramChannelLimitExceed: success.response.instagramChannelLimitExceed,
          selectCheckBoxLimit: success.response.selectCheckBoxLimit
        })
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  checkPeriscopeCallbackUrl = () => {
    let params = new URLSearchParams(this.props.location.search)
    if (params.get('code')) {
      let code = params.get('code');
      this.props.history.push('/dashboard/social/platform');
      return this.getOauthToken(code);
    }
  }

  responseFacebook = (response) => {
    this.setState({ startLoader: !this.state.startLoader })
    $.ajax({
      method: 'GET',
      url: 'https://graph.facebook.com/v15.0/me?fields=accounts&access_token=' + response.accessToken,
      success: (success) => {
        let fbPages = [];
        if (success.accounts) {
          fbPages = success.accounts.data.map((pages) => {
            if (pages.access_token)
              return {
                access_token: pages.access_token,
                id: pages.id,
                name: pages.name
              }
          })
        }
        this.addFacebookDetail(response, fbPages);
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  googleLoginResponse = (user) => {
    $.ajax({
      method: 'POST',
      url: '/api/v1/social/media',
      data: JSON.stringify({
        type: 'YOUTUBE',
        code: user.code
      }),
      success: (success) => {
        this.componentDidMount();
        this.props.notifySuccess(success.message);
      },
      error: (err) => {
        this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  addFacebookDetail = (fbTimeLine, fbPages) => {
    let data = this.fbBodyData(fbTimeLine, fbPages);
    data.fbPages.push({
      name: fbTimeLine.name,
      id: fbTimeLine.id,
      access_token: fbTimeLine.accessToken,
      type: 'Timeline'
    })
    data.access_token = fbTimeLine.accessToken;
    data.timelineId = fbTimeLine.id;
    $.ajax({
      method: 'POST',
      url: '/api/v1/social/media',
      data: JSON.stringify({
        data: data
      }),
      success: (success) => {
        if (success) {
          this.componentDidMount();
          this.props.notifySuccess(success.message);
        }
        this.setState({ startLoader: !this.state.startLoader })
      },
      error: (err) => {
        this.setState({ startLoader: !this.state.startLoader })
        this.props.notifyError(err.responseJSON.message);
      }
    })
  }

  getAllSocialMedia = () => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/social/media',
      success: (success) => {
        if (success.response.length) {
          let facebookMedia = [];
          let customMedia = [];
          let youtubeMedia = [];
          let instagramMedia = [];
          let periscope = [];
          success.response.forEach(socialMedia => {
            if (socialMedia.type == "FACEBOOK") {
              facebookMedia.push(socialMedia);
            }
            if (socialMedia.type == 'CUSTOM') {
              delete socialMedia.fbPages;
              customMedia.push(socialMedia);
            }
            if (socialMedia.type == 'YOUTUBE') {
              delete socialMedia.fbPages;
              youtubeMedia.push(socialMedia);
            }
            if (socialMedia.type == 'INSTAGRAM') {
              delete socialMedia.fbPages;
              instagramMedia.push(socialMedia);
            }
            if (socialMedia.type == 'PERISCOPE') {
              delete socialMedia.fbPages;
              periscope.push(socialMedia);
            }
          });

          this.setState({
            facebookAccount: facebookMedia,
            customMediaDetail: customMedia,
            youtubeMediaDetail: youtubeMedia,
            instagramMediaDetail: instagramMedia,
            periscope: periscope
          });
        }
        else {
          this.setState({
            facebookAccount: [],
            customMediaDetail: [],
            youtubeMediaDetail: [],
            instagramMediaDetail: []
          });
        }
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  fbBodyData = (fbTimeLine, fbPages) => {
    return {
      email: fbTimeLine.email,
      name: fbTimeLine.name,
      type: 'FACEBOOK',
      fbPages: fbPages
    }
  }

  checkLimitOfCheckedBox = (typeId) =>{
    var allCheckBox = document.querySelectorAll(".pageCheckbox");
    if (allCheckBox && allCheckBox.length) {
      let filterElement =  _.filter(allCheckBox,(element) => {
        return element.checked;
      })
      if(filterElement.length > this.state.selectCheckBoxLimit){
        document.getElementById(typeId).checked = false;
        return true;
      }
      return false;
    }
  }

  selectPagesToBroadcast = (pages, i, j) => {
    let typeId = "checkbox" + i + j;
    if(this.checkLimitOfCheckedBox(typeId)) return;
    pages.status = document.getElementById(typeId).checked;
    $.ajax({
      method: 'POST',
      url: '/api/v1/add/facebook',
      data: JSON.stringify(pages),
      success: (success) => {
        if (success)
          this.componentDidMount();
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  selectPagesForCustomBroadcast = (custom, i) => {
    let typeId = custom.type.toLowerCase() + '-checkbox' + i;
    if(this.checkLimitOfCheckedBox(typeId)) return;
    custom.selected = document.getElementById(typeId).checked;
    $.ajax({
      method: 'PUT',
      url: '/api/v1/select/customPage',
      data: JSON.stringify(custom),
      success: (success) => {
        if (success)
          this.componentDidMount();
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  logoutFromFacebook = (socialPlatform) => {
    let data = { id: socialPlatform._id, type: socialPlatform.type };
    if (socialPlatform.type == 'PERISCOPE') {
      data.access_token = socialPlatform.access_token;
      data.broadcastId = socialPlatform.twitterBroadcast.broadcastId;
    }
    let self = this;
    this.setState({ startLoader: !this.state.startLoader })

    $.ajax({
      method: 'DELETE',
      url: '/api/v1/facebook/logout',
      data: JSON.stringify(data),
      success: (success) => {
        this.setState({ startLoader: !this.state.startLoader })
        if (success) {
          self.getAllSocialMedia();
          self.socialMediaChannelLimit();
          self.props.notifySuccess(success.message);
        }
      },
      error: (err) => {
        this.setState({ startLoader: !this.state.startLoader })
        self.props.notifyError(err.responseJSON.message);
      }
    });
  }

  youtubeLoginPopup = () => {
    this.setState({
      youtubeLoginPopup: !this.state.youtubeLoginPopup
    })
  }

  openCustomSocialModal = () => {
    this.setState({
      customSocialMedia: !this.state.customSocialMedia
    })
  }


  changeUsername = (e) =>{
    this.setState({
      username: e.target.value
    })
  }

  changePassword = (e) =>{
    this.setState({
      password: e.target.value
    })
  }

  customRTMPOptions = () => {
    let items = [];
    for (let i = 0; i < this.state.customRTMPSites.length; i++) {
      items.push(<option key={i} value={this.state.customRTMPSites[i]}>{this.state.customRTMPSites[i]}</option>);
    }
    return items;
  }
  customRTMPURL = (e) => {
    this.setState({ customSite: e.target.value });
  }
  customSocialMediaRtmp = (e) => {
    this.setState({ customRtmpUrl: e.target.value });
  }
  customSocialMediaStreamKey = (e) => {
    this.setState({ customStreamKey: e.target.value });
  }

  customSocialMediaName = (e) => {
    this.setState({ customName: e.target.value });
  }

  addCustomSocialMedia = (event) => {
    event.preventDefault();
    let data = {
      type: 'CUSTOM',
      customRtmp: this.state.customRtmpUrl,
      customStreamKey: this.state.customStreamKey,
      name: this.state.customName,
      platformType: this.state.customSite,
      custom_username: this.state.username,
      custom_password: this.state.password
    }
    if(this.state.customSite === "Instagram") data.broadcastType = this.state.broadcastType
    this.openCustomSocialModal();
    if (data.customRtmp && data.customStreamKey && data.name && data.platformType) {
      $.ajax({
        method: 'POST',
        url: '/api/v1/social/media',
        data: JSON.stringify(data),
        success: (success) => {
          if (success) {
            this.props.notifySuccess(success.message);
            this.componentDidMount();
          }
        },
        error: (err) => {
          this.props.notifyError(err.responseJSON.message);
        }
      });
    }
  }

  redirectLinkToGetCustomRtmpAndStreamKey = () => {

    if(this.state.customSite === "Youtube") {
      return (<Media>Nota: Para gerar um URL RTMP e uma chave secreta do YouTube, acesse a página "Transmitir ao vivo" do YouTube. <a href="https://www.youtube.com/my_live_events" target="_blank">Clique aqui</a></Media>)
    } else if(this.state.customSite === "Facebook") {
      return (<Media>Nota: Para gerar um URL RTMP e uma chave secreta do Facebook, acesse a página "Transmitir ao vivo" do Facebook. <a href="https://www.facebook.com/live/create" target="_blank">Clique aqui</a></Media>)
    } else if(this.state.customSite === "Instagram") {
      return (<Media>Nota: Para gerar uma chave RTMP do Instagram, sua conta do Instagram deve estar configurada como uma conta Profissional. <a href="https://www.instagram.com/" target="_blank"> Clique aqui</a></Media>);
    } else {
      return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://restream.io/channel" target="_blank">Clique aqui</a></Media>);
    }


    // if (this.state.customSite == this.state.customRTMPSites[0])
    //   return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://www.pscp.tv/account/producer" target="_blank"> Clique aqui</a> </Media>);
    // if (this.state.customSite == this.state.customRTMPSites[1])
    //   return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://www.twitch.tv/broadcast/dashboard/streamkey" target="_blank"> Clique aqui</a></Media>);
    // if (this.state.customSite == this.state.customRTMPSites[2])
    //   return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://www.youtube.com/my_live_events" target="_blank"> Clique aqui</a></Media>);
    // if (this.state.customSite == this.state.customRTMPSites[3])
    //   return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://www.facebook.com/live/create" target="_blank"> Clique aqui</a></Media>);
    // if (this.state.customSite == this.state.customRTMPSites[4])
    //   return (<Media>Nota: Para gerar uma chave RTMP do Instagram, sua conta do Instagram deve estar configurada como uma conta Profissional. <a href="https://www.instagram.com/" target="_blank"> Clique aqui</a></Media>);
    // if (this.state.customSite == this.state.customRTMPSites[5])
    //   return (<Media>Nota: você pode gerar a URL do rtmp do {this.state.customSite} e a chave do fluxo, <a href="https://restream.io/channel" target="_blank"> Clique aqui</a></Media>);

  }

  sendInvitationLink = () => {
    let data = {
      email: this.state.invitationEmail,
      host: window.location.protocol + "//" + window.location.hostname,
    }
    $.ajax({
      method: 'POST',
      url: '/api/v1/send/invitation',
      data: JSON.stringify(data),
      success: (success) => {
        if (success) {
          this.props.notifySuccess(success.message);
        }
      },
      error: (err) => {
        this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  changeInvitationEmailText = (e) => {
    this.setState({
      invitationEmail: e.target.value
    });
  }

  loginTwitter = () => {
    window.location.href = 'https://www.pscp.tv/oauth?response_type=code&client_id=cyUhdpVYI5Gt4Jp6l-qObJku1RNUaaXwNtt4pt5ZmcwkW8ryII&redirect_uri=' + window.location.href;
  }

  getOauthToken = (code) => {
    $.ajax({
      method: 'POST',
      url: '/api/v1/periscope/token',
      data: JSON.stringify({
        code: code
      }),
      success: function (success) {
        this.getAllSocialMedia();
        this.socialMediaChannelLimit();
        // setTimeout(() => { this.getAllSocialMedia(); }, 3000)
        this.props.notifySuccess(success.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }


  googleLoginError = (error) => {
    console.log('error-->', error)
  }

  updateBrodacastType = (e) => {
    this.setState({ broadcastType: e.target.value})
  }

  render() {
    return (
      <div className="container"> 
        <div className="row">
          <div className="col-md-11 col-sm-10 col-xs-10 relay-header">
          <Loader loaded={this.state.startLoader}></Loader>
            <h3 className="dashboard-Title">Bem Vindo ao Relay Stream</h3>
            <h4 className="relay-border-bottom border-width">ADICIONAR</h4>
            <div className="cards-row">
              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Facebook
                    <FacebookLogin
                      appId={this.state.fbClientId}
                      fields="email, name"
                      scope="email, publish_video, public_profile, pages_read_engagement, pages_manage_posts, pages_show_list"
                      version="7.0"
                      callback={this.responseFacebook}
                      render={renderProps => (
                        <button className="btn add-account-btn" onClick={renderProps.onClick} disabled={this.state.facebookChannelLimitExceed ? true : false}>Add Account</button>
                      )} />
                  </h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.facebookAccount.length ?
                      this.state.facebookAccount.map((facebook, j) => {
                        if (!facebook.invitationToken)
                          return (
                            <div key={j} className='social-cards-container email-cards'>
                              <div className="profilePic">
                                <img src={facebook.profilePic} className="circle" />
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="email-label text-ellipses">Email</label>
                                  <span className="text-ellipses">{facebook.email}</span>
                                  <button className="logout-label" onClick={() => { this.logoutFromFacebook(facebook) }}>Logout</button>
                                  <div className="row pagesScroll">
                                    {
                                      facebook.fbPages.length ? facebook.fbPages.map((pages, i) => {
                                        if (pages.type == 'Timeline') {
                                          return (
                                            <div key={i} className="timeLineCheckbox timeline-border-bottom">
                                              <input id={"checkbox" + i + j} type="checkbox" className="facebookPages pageCheckbox" value={pages} onClick={() => { this.selectPagesToBroadcast(pages, i, j) }} defaultChecked={pages.selected} />
                                              <span>{"Time Line"}</span>
                                            </div>
                                          )
                                        }
                                      }) : null
                                    }
                                    <ul className={facebook.fbPages.length >= 8 ? "checkbox" : "timeLineCheckBoxLeastPage"}>
                                      {
                                        facebook.fbPages.length ?
                                          facebook.fbPages.map((pages, i) => {
                                            pages.email = facebook.email;
                                            if (pages.type != 'Timeline') {
                                              return (
                                                <li key={i}>
                                                  <input id={"checkbox" + i + j} type="checkbox" className="facebookPages pageCheckbox" value={pages} onClick={() => { this.selectPagesToBroadcast(pages, i, j) }} defaultChecked={pages.selected} />
                                                  <span>{pages.name}</span>
                                                </li>
                                              )
                                            }
                                          }) : null
                                      }
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      }) : null
                  }
                </div>
              </div>
              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">YouTube
                    <GoogleLogin
                      apiKey="AIzaSyDB9Yr7gO_k4ZNub-5fCiPYafIAKO2-oqc"
                      clientId="242384257630-cutoeuml04eq6e80t2rpg83leu0vpm97.apps.googleusercontent.com"
                      client_secret="fsbPEjKRlM0JnklcTfj5Sjav"
                      scope="https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly"
                      discoveryDocs='https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'
                      prompt='consent'
                      access_type='offline'
                      responseType='code'
                      render={renderProps => (
                        <button type="button" className="btn add-account-btn" onClick={renderProps.onClick} disabled={this.state.youtubeChannelLimitExceed ? true : false}> Add Account </button>
                      )}
                      onSuccess={this.googleLoginResponse}
                      onFailure={this.googleLoginError}
                      cookiePolicy={'single_host_origin'}
                    />
                  </h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.youtubeMediaDetail.length ?
                      this.state.youtubeMediaDetail.map((youtubeMedia, j) => {
                        if (!youtubeMedia.invitationToken)
                          return (
                            <div key={j} className={this.state.youtubeMediaDetail.length > 2 ? 'social-cards-container' : 'social-cards-container youtubegrid'}>
                              <div className="profilePic">
                                <img src={youtubeMedia.profilePic} className="circle" />
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="email-label text-ellipses">Email</label>
                                  <span className="text-ellipses">{youtubeMedia.email}</span>
                                  <button className="logout-label youtube-logout" onClick={() => { this.logoutFromFacebook(youtubeMedia) }}>Logout</button>
                                  <div className="timeLineCheckbox">
                                    <input id={"youtube-checkbox" + j} type="checkbox" className="facebookPages pageCheckbox" value={youtubeMedia} onClick={() => { this.selectPagesForCustomBroadcast(youtubeMedia, j) }} defaultChecked={youtubeMedia.selected} />
                                    <span>{youtubeMedia.name}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      }) : null
                  }
                </div>
              </div>

              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Custom
                    <button className="btn add-account-btn" onClick={this.openCustomSocialModal}>Add Account</button>
                  </h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.customMediaDetail.length ?
                      this.state.customMediaDetail.map((custom, i) => {
                        return (
                          <div className={this.state.customMediaDetail.length > 3 ? 'social-cards-container' : 'social-cards-container youtubegrid'} key={i}>
                            {/* <img src={custom.name.charAt(0).toUpperCase()} className="circle profilePic" /> */}
                            <div className="row">
                              <div className="col-md-12">
                                <label className="email-label text-ellipses ">{custom.platformType}</label>
                                {/* <span className="text-ellipses">{custom.name}</span> */}
                                <input id={"custom-checkbox" + i} type="checkbox" className="facebookPages pageCheckbox" value={custom} onClick={() => { this.selectPagesForCustomBroadcast(custom, i) }} defaultChecked={custom.selected} />
                                <span>{custom.name}</span>
                                <button className="logout-label custom-logout" onClick={() => { this.logoutFromFacebook(custom) }}>Logout</button>
                              </div>
                            </div>
                          </div>
                        )
                      }) : null
                  }
                </div>
              </div>
            </div>
            <div>
            </div>

            <div className="cards-row">
              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Instagram
                    <button className="btn add-account-btn" disabled={this.state.instagramChannelLimitExceed ? true : false} onClick={this.instagramLoginWindow} >Add Account</button>
                  </h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.instagramMediaDetail.length ?
                      this.state.instagramMediaDetail.map((instagramMedia, j) => {
                        return (
                          <div key={j} className={this.state.instagramMediaDetail.length > 2 ? 'social-cards-container' : 'social-cards-container youtubegrid'}>
                            <div className="profilePic">
                              <img src={instagramProfilePic} className="circle" />
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <label className="email-label text-ellipses">Username</label>
                                <span className="text-ellipses">{instagramMedia.email}</span>
                                <button className="logout-label youtube-logout" onClick={() => { this.logoutFromFacebook(instagramMedia) }}>Logout</button>
                                <div className="timeLineCheckbox">
                                  <input id={"instagram-checkbox" + j} type="checkbox" className="facebookPages pageCheckbox" value={instagramMedia} onClick={() => { this.selectPagesForCustomBroadcast(instagramMedia, j) }} defaultChecked={instagramMedia.selected} />
                                  <span>{instagramMedia.name ? instagramMedia.name : instagramMedia.email}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }) : null
                  }
                </div>
              </div>
              {/* <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Twitter
                    <button className="btn add-account-btn" disabled={this.state.twitterChannelLimitExceed ? true : false} onClick={this.loginTwitter} >Add Account</button>
                  </h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.periscope.length ?
                      this.state.periscope.map((periscope, j) => {
                        return (
                          <div key={j} className={this.state.periscope.length > 2 ? 'social-cards-container' : 'social-cards-container youtubegrid'}>
                            <div className="profilePic">
                              <img src={periscope.profilePic} className="circle" />
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <label className="email-label text-ellipses">Username</label>
                                <span className="text-ellipses">{periscope.email}</span>
                                <button className="logout-label youtube-logout" onClick={() => { this.logoutFromFacebook(periscope) }}>Logout</button>
                                <div className="timeLineCheckbox">
                                  <input id={"periscope-checkbox" + j} type="checkbox" className="facebookPages pageCheckbox" value={periscope} onClick={() => { this.selectPagesForCustomBroadcast(periscope, j) }} defaultChecked={periscope.selected} />
                                  <span>{periscope.name}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      }) : null
                  }
                </div>
              </div> */}
            </div>
            {
              this.state.instagramChannelLimitExceed ?
                <span style={{ color: "red" }} placement="top" target="instagramBtn">
                  Seu Plano permite apenas 1 conta instagram, faça  um upgrade
                </span> :
                null
            }

            <hr className="cards-hr"></hr>

            <div className="cards-row">
              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Digital Email</h3>
                </div>
                <div className="AppLive__body digital-email">
                  <FormGroup>
                    <InputGroup >
                      <Input type="text" defaultValue={this.state.invitationEmail} onChange={this.changeInvitationEmailText} name="URL-FMS" />
                      <InputGroupAddon addonType="append">
                        <Clipboard button-title="Copy FMS URL" button-className="btn btn-secondary rtmpButton" onClick={this.sendInvitationLink}>
                          Envier
                        </Clipboard>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>

              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">Facebook - Canvidados</h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.facebookAccount.length ?
                      this.state.facebookAccount.map((facebook, j) => {
                        if (facebook.invitationToken)
                          return (
                            <div className='social-cards-container email-cards' key={j}>
                              <div className="profilePic">
                                <img src={facebook.profilePic} className="circle" />
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="email-label text-ellipses">Email</label>
                                  <span className="text-ellipses">{facebook.email}</span>
                                  <button className="logout-label" onClick={() => { this.logoutFromFacebook(facebook) }}>Logout</button>

                                  <div className="row pagesScroll">
                                    {
                                      facebook.fbPages.length ? facebook.fbPages.map((pages, i) => {
                                        if (pages.type == 'Timeline') {
                                          return (
                                            <div className="timeLineCheckbox timeline-border-bottom">
                                              <input id={"checkbox" + i + j} type="checkbox" className="facebookPages pageCheckbox" value={pages} onClick={() => { this.selectPagesToBroadcast(pages, i, j) }} defaultChecked={pages.selected} />
                                              <span>{"Time Line"}</span>
                                            </div>
                                          )
                                        }
                                      }) : null
                                    }
                                    <ul className={facebook.fbPages.length >= 8 ? "checkbox" : "timeLineCheckBoxLeastPage"}>
                                      {
                                        facebook.fbPages.length ?
                                          facebook.fbPages.map((pages, i) => {
                                            pages.email = facebook.email;
                                            if (pages.type != 'Timeline') {
                                              return (
                                                <li key={i}>
                                                  <input id={"checkbox" + i + j} type="checkbox" className="facebookPages pageCheckbox" value={pages} onClick={() => { this.selectPagesToBroadcast(pages, i, j) }} defaultChecked={pages.selected} />
                                                  <span>{pages.name}</span>
                                                </li>
                                              )
                                            }
                                          }) : null
                                      }
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      }) : null
                  }
                </div>
              </div>
              <div className="col-md-4 social-cards">
                <div className="relay-border-bottom social-cards-header">
                  <h3 className="h3-cards">YouTube - Canvidados</h3>
                </div>
                <div className="row-md-5 socialEmails" >
                  {
                    this.state.youtubeMediaDetail.length ?
                      this.state.youtubeMediaDetail.map((youtubeMedia, j) => {
                        if (youtubeMedia.invitationToken)
                          return (
                            <div key={j} className={this.state.youtubeMediaDetail.length > 2 ? 'social-cards-container' : 'social-cards-container youtubegrid'}>
                              <div className="profilePic">
                                <img src={youtubeMedia.profilePic} className="circle" />
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="email-label text-ellipses">Email</label>
                                  <span className="text-ellipses">{youtubeMedia.email}</span>
                                  <button className="logout-label youtube-logout" onClick={() => { this.logoutFromFacebook(youtubeMedia) }}>Logout</button>
                                  <div className="timeLineCheckbox">
                                    <input id={"youtube-checkbox" + j} type="checkbox" className="facebookPages pageCheckbox" value={youtubeMedia} onClick={() => { this.selectPagesForCustomBroadcast(youtubeMedia, j) }} defaultChecked={youtubeMedia.selected} />
                                    <span>{youtubeMedia.name}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      }) : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal className="customRtmpModal" isOpen={this.state.customSocialMedia} toggle={this.openCustomSocialModal} >
          <ModalBody>
            <Form className="AddCollaboratorForm DataFields" onSubmit={this.addCustomSocialMedia}>
              <span onClick={this.openCustomSocialModal} className="closeModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
              <div className="form-group">
                <label className="mr-sm-2">
                  Destino</label>
                <Select type="select" name="destination" className="form-control" value={this.state.customSite} onChange={this.customRTMPURL} >
                  {this.customRTMPOptions()}
                </Select>
                {this.redirectLinkToGetCustomRtmpAndStreamKey()}

              </div>
              <div className="form-group ">
                <Label for="name">Nome</Label>
                <Input type="text" name="rtmp_url" value={this.state.customName} autoComplete="off" onChange={this.customSocialMediaName} className="form-control" />
              </div>
              <div className="form-group ">
                <Label for="name" >RTMP URL</Label>
                <Input type="text" name="rtmp_url" value={this.state.customRtmpUrl} autoComplete="off" onChange={this.customSocialMediaRtmp} className="form-control" />
              </div>
              <div className="form-group ">
                <Label for="privacy">Chave secreta</Label>
                <Input type="text" name="stream_key" value={this.state.customStreamKey} autoComplete="off" onChange={this.customSocialMediaStreamKey} className="form-control" />
              </div>
              {this.state.customSite === "Instagram" && <div className='form-group'>
                <Label className="broadcastType">Orientação de vídeo</Label>
                <div className='d-flex' style={{height:"20px"}}> 
                  <input type="radio" name="broadcastType" className="form-control" value="normal" onChange={this.updateBrodacastType} style={{height:"20px"}}/>Normal
                  <input type="radio" name="broadcastType" className="form-control" value="paisagem" onChange={this.updateBrodacastType} style={{height:"20px"}}/>Paisagem
                  <input type="radio" name="broadcastType" className="form-control" value="square" onChange={this.updateBrodacastType} style={{height:"20px"}}/>Square                
                </div>
              </div>}
              <div className="form-group">
                <label className="mr-sm-2">
                Nome do usuário</label>
                <Input type="text" name="username" id="" defaultValue={this.state.username} onChange={this.changeUsername} className="form-control" />
              </div>
              <div className="form-group">
                <label className="mr-sm-2">
                Senha</label>
                <Input type="password" name="password" id="" defaultValue={this.state.password} onChange={this.changePassword} className="form-control" />
              </div>
              <FormGroup className="text-center">
                <Button type="submit" className="btn btn--submit mx-auto">SUBMIT</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }

}
export default SocialPage;




// WEBPACK FOOTER //
// ./src/components/SocialPlatform/SocialPage.js